import create from 'zustand';

export type MessageModalStore = {
    message: string;
    setMessage: (message: string) => void;
};

export const useMessageModalStore = create<MessageModalStore>((set) => ({
    message: "",
    setMessage: (message) =>
        set((state) => ({
            message: message,
        })),
}));
